const MARGIN = 8;

/**
 * Viewport position for a popup of `size` opened from `anchor` (a client
 * rect): to the right of the anchor, else to its left, else below it —
 * always kept inside `viewport` (DM-10455).
 */
export function placeNextToAnchor(anchor, size, viewport, margin = MARGIN) {
  const maxLeft = viewport.width - margin - size.width;
  const maxTop = viewport.height - margin - size.height;

  let left = anchor.right + margin;
  let top = anchor.top;

  if (left > maxLeft) {
    left = anchor.left - margin - size.width;
  }
  if (left < margin) {
    left = anchor.left;
    top = anchor.bottom + margin;
  }

  return {
    left: Math.max(margin, Math.min(left, maxLeft)),
    top: Math.max(margin, Math.min(top, maxTop)),
  };
}
